import { requestJson, assertOk} from "./storeApi"

export async function fetchOrders() {
    const { response, payload } = await requestJson("/orders/index", {
        method: "GET",
        credentials: "include",
    });
    return assertOk(response, payload, "Failed to load orders");
}

export async function updateTrackingNumber(orderID, trackingNumber) {
    const { response, payload } = await requestJson("/shipping/update-tracking", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ order_id: orderID, tracking_number: trackingNumber }),
    });
    return assertOk(response, payload, "Failed to update tracking number");
}


export async function getOrderHistory(customerID) {
    const { response, payload } = await requestJson(`/customers/orderHistory/${customerID}`, {
        method: "GET",
        credentials: "include",
    });
    return assertOk(response, payload, "Failed to load order history");
}